import MessageList from 'src/storage/treatmentsList';

class SettingStatsModel extends MessageList {
  id = 'SettingStatsModel';
  persistent = false;
  refreshOnInit = false;
  refreshOnSubscribe = true;
  listLimit = 5;
  defaultState = () => ({
    current: 'recent'
  });
  apiConfig = {};
  subId = '';
  params = {};

  _events = {
    profile: 'handleProfile',
    'foxsocket:message:msg': 'onMessage',
    'foxsocket:message:msg_update': 'onMessageUpdateWS'
  };
  constructor(sub, params = {}, subUrl = '/refresh') {
    super(sub);
    this.subId = sub;
    this.params = params;
    this.apiConfig.refresh = {
      url: sub + subUrl,
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    };
  }

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  filterItem = (data) => data.msgType === this.subId || this.subId === 'message';

  listParams(loadMore) {
    if (loadMore) {
      return null;
    }
    return {
      skip: 0,
      limit: this.listLimit,
      ...this.params
    };
  }
}

const modelPatient = new SettingStatsModel('patient');
const modelAppointment = new SettingStatsModel('appointment', {
  partnerId: 0,
  statusGroup: []
});
const modelTreatment = new SettingStatsModel('treatment', {
  partnerId: 0
});
const modelMessage = new SettingStatsModel('message', {}, '/latest');
const model = { modelPatient, modelAppointment, modelTreatment, modelMessage };
export default model;
